<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title" v-if='$route.query.type == "look"'>经销商详情</span>
      <span class="ml15 card_title" v-else>{{$route.query.type == 'add' ? '添加':'修改'}}经销商</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item v-if='false' ref="dealer_sn" label="经销商编号" name="dealer_sn" help='最多20个字符，只能包含英文、数字、英文符号“-” “_”，不能与已存在经销商编号重复'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input :disabled='$route.query.type !== "add"' v-model:value="form.dealer_sn" placeholder='请输入经销商编号' v-inputFilter:sn />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="dealer_name" label="经销商名称" name="dealer_name">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.dealer_name" :readonly='$route.query.type == "look"' placeholder='请输入经销商名称' />
            </a-col>
            <a-col :span="12">
              <p>最多50个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="leader_name" label="负责人" name="leader_name">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.leader_name" :readonly='$route.query.type == "look"' placeholder='请输入经销商负责人姓名' />
            </a-col>
            <a-col :span="12">
              <p>最多8个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="leader_phone" label="手机号码" name="leader_phone">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.leader_phone" :readonly='$route.query.type == "look"' :maxlength='11' placeholder='请输入经销商联系人手机号码' />
            </a-col>
            <a-col :span="12">
              <p> <span style="color:#f04635;font-weight:600;font-size:13px">(手机号码也是经销商登录账号,请谨慎操作)</span></p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="password" label="设置密码" name="password" v-if='$route.query.type == "add"'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input-password v-model:value="form.password" placeholder='请输入密码' />
            </a-col>
            <a-col :span="12">
              <p>6-20个非中文字符</p>
            </a-col>
          </a-row>
        </a-form-item>
           <a-form-item ref="business_license_image" label="营业执照"   
            >
              <div class="s_po_re" v-if='$route.query.type !="look"'>
                <material :groupType='1'   :image="form.business_license_image" :max="1" v-on:handlechoose="(data)=>{form.business_license_image=data}" v-on:handledel="(data)=>{form.business_license_image=''}" />
                <div class="s_po_ab_bl" style="width: 100%;height: 100%;" v-if='$route.query.type =="look" || $route.query.type == "review"'></div>
              </div>
              <div class='ant-upload-list ant-upload-list-picture-card' v-else>
                <div class='ant-upload-list-picture-card-container' v-if='form.business_license_image'>
                  <span>
                    <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                      <div class="ant-upload-list-item-info">
                        <img :src="info.picdomain+'/'+form.business_license_image" class='ant-upload-list-item-image' />
                      </div>
                    </div>
                  </span>
                </div>
                <p v-else class="height-39 s_flex_ali">无</p>
              </div>
            </a-form-item>
        <a-form-item ref="address_list" label="经销商地址" name="address_list">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-cascader v-model:value="form.address_list" :disabled='$route.query.type == "look"' :field-names="{ label: 'name', value: 'id', children: 'children' }" :options="addressList" placeholder="请选择经销商地址" @change="onChangeAddress" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="address" label="详细地址" name="address">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.address" :readonly='$route.query.type == "look"' placeholder='请输入详细地址' @change="changeVal" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="lng" label="经纬度" name="lng" :rules="[{ required: true, message: '请选择经纬度' }]">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-input v-model:value="form.lat" readonly placeholder='请输入经度' />
            </a-col>
            <a-col :span="6">
              <a-input v-model:value="form.lng" readonly placeholder='请输入纬度' />
            </a-col>
            <a-col :span="12">
              <a-button type="primary" @click='showMap = true' :disabled='$route.query.type == "look"'>
                搜索
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="推荐经销商">
           <p>{{form.extension_dealer_name || '无'}}</p>
        </a-form-item>
        <a-form-item ref="level_id" label="经销商等级" name="level_id" :help='$route.query.type == "edit"?"（如已有下级则不支持修改；如改后不是一级，则需同步分配上级）":""'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-select v-model:value="form.level_id" placeholder="请选择经销商等级" :disabled='$route.query.type == "look" || form.has_son == 1' @change='selectLevel'>
                <a-select-option v-for='item in levelList' :key='item.P_level_id' :value="item.level_id">
                  {{item.level_name}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="12">
              <a href="javascript:;" @click="showDealerLevel = true">设置经销商级别</a>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="up_name" label="上级经销商" name="up_name" :rules="[{ required: true, message: '请选择上级经销商' }]" v-if='dealerLevel != 1' :help='$route.query.type == "edit"?editText:""'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.up_name" readonly placeholder='请选择上级经销商' />
            </a-col>
            <a-col :span="12">
              <a-button type="primary" @click='showDealer = true' :disabled='$route.query.type == "look" || !form.level_id'>
                选择
              </a-button>
            </a-col>
          </a-row>
          <div class="region_list" v-if='superiorArea.length > 0' v-show="dealerSelectType">
            销售区域：
            <span v-for='item in superiorArea' :key='item'>
              <span>{{item.country_name}}</span>
              <span>{{item.province_name}}</span>
              <span>{{item.city_name ?'-'+item.city_name:''}}</span>
              <span>{{item.area_name ?'-'+item.area_name:''}}</span>
              <span class="don">、</span>
            </span>
          </div>
        </a-form-item>
        <a-form-item label="所属品牌">
          <selectBrand  v-model:value="form.sub_brand_id" :sub_brand_id="Number(form.sub_brand_id)" :disabled='$route.query.type == "look"' />
          <a-button class="m-l-10" @click="form.sub_brand_id=''" :disabled='$route.query.type == "look"'>清空</a-button>
        </a-form-item>
        <a-form-item ref="" required label="销售区域" name="" help='最多20个区域，区域不能重叠或重复，销售区域不能超出上级销售区域'>
          <a-row class="m-b-15" type="flex" justify="space-between" align="middle">
            <a-col :span="8">
              <div class="">
                <a-select v-model:value="country" placeholder="请选择">
                  <a-select-option :value="100000">全国</a-select-option>
                </a-select>
                <a-select v-model:value="province" allowClear placeholder="请选择省" @change="selectProvince">
                  <a-select-option v-for='(item,index) in provinceList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
                <a-select v-model:value="city" allowClear placeholder="请选择市" @change="selectCity">
                  <a-select-option v-for='(item,index) in cityList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
                <a-select v-model:value="area" allowClear placeholder="请选择区" @change="selectArea">
                  <a-select-option v-for='(item,index) in areaList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :span="2">
              <a-button type="primary" @click="addCity" :disabled='$route.query.type == "look"'>添加</a-button>
            </a-col>
            <a-col :span="8">
              <div class="s_bor10 p-5 height-160" style="overflow-x: auto;overflow-y:scroll;border:1px solid #ccc">
                <div class="s_flex_bian_c s_bf58 bor-rad-5 p-tb0-lr10 m-b-10" v-for='(item,index) in rigthArr' :key='index'>
                  <p>{{item.country_name}}{{item.province_name}}{{item.city_name}}{{item.area_name}}</p>
                  <CloseCircleFilled class="s_c999" v-if='$route.query.type == "look"' />
                  <CloseCircleFilled class="s_c999" @click='delRegion(index)' v-else />
                </div>
              </div>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="sale_cat_id" label="销售大区" name="sale_cat_id"  v-if="form.up_name=='总部' || form.level_id==1">
             <a-select v-model:value="form.sale_cat_id" placeholder="请选择" style="width:50%">
                  <a-select-option :value="v.id" v-for="v in SaleCatList" :key="v.id">{{v.sale_cat_name}}</a-select-option>
             </a-select>
        </a-form-item> 
        <a-form-item class="m-t-25" :wrapper-col="{ span: 8, offset: 2 }" v-if='$route.query.type !== "look"'>
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer   :is_sub_dealer="1" v-on:select="dealerSelect" :levelid='level' :mustShowHeadquarters='true'></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" title="选择经纬度" centered v-model:visible="showMap" :width='1300' :footer="null" destroyOnClose>
    <gdmap v-on:confirm="confirm" :provinceData='mapProvince' :address='form.address' :lng='form.lng' :lat='form.lat'></gdmap>
  </a-modal>
  <a-modal  :keyboard="false" title="添加经销商级别" centered v-model:visible="showDealerLevel" :width='1300' :footer="null" destroyOnClose>
    <dealerTypeAdd v-on:dealerlevelsubmit="dealerlevelsubmit"></dealerTypeAdd>
  </a-modal>
</template>
<script>
import { LeftOutlined, CloseCircleFilled } from '@ant-design/icons-vue';
import { ref, onMounted, reactive, toRefs, inject } from 'vue';
import { message } from 'ant-design-vue';
import { getArea } from '@/api/public';
import store from "@/store";
import {
  dealerAdd,
  getDealerMore,
  dealerEdit,
  getDealerLevelList,
  getSaleCat
} from '@/api/dealer';
import { iscode } from '@/utils/app';
// 初始化默认筛选项数值
let defForm = {
  dealer_sn: '',
  dealer_name: '',
  province: '',
  city: '',
  region: '',
  address: '',
  address_list: [],
  password: 123456,
  leader_name: '',
  leader_phone: '',
  level_id: undefined,
  parent_dealer_id: 0,
  sale_area: [],
  lng: '',
  lat: '',
  up_name: '',
  business_license_image:'',
  payee_account: '',
  sale_area_text: [],
  is_sub_dealer: 1,
  sale_cat_id:undefined,//销售大区ID
  extension_dealer_name:''
};
export default {
  components: {
    LeftOutlined,
    CloseCircleFilled,
  },
  setup() {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      info: store.state.user.info,
      editText:
        '（如该经销商存在未完成的报销，请报销完毕后再进行上下级变更，否则这部分报销数据可能会出现数据异常）',
      level: null,
      dealerLevel:null,
      superiorArea: [],
      showDealer: false,
      country: 100000,
      province: undefined,
      city: undefined,
      area: undefined,
      cityIndex: undefined,
      addressList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      cityObj: {
        country_name: '',
        province_name: '',
        city_name: '',
        area_name: '',
        id: [],
      },
      rigthArr: [],
      mapProvince: {
        province_name: '',
        city_name: '',
        area_name: '',
      },
      showMap: false,
      showDealerLevel: false,
      dataSource: [],
      targetKeys: [],
      fileList: [],
      loading: false,
      imageUrl: '',
      previewVisible: false,
      previewImage: '',
      labelCol: { span: 2 },
      wrapperCol: { span: 10 },
      levelList: [],
      dealerSelectType:true,
      rules: {
        dealer_sn: [
          { required: true, message: '请输入经销商编号' },
          { max: 20, message: '最多20个字符', trigger: 'blur' },
        ],
        dealer_name: [{ required: true, message: '请输入经销商名称' }],
        leader_name: [{ required: true, message: '请输入负责人姓名' }],
        leader_phone: [{ required: true, message: '请输入手机号码' }],
        address_list: [{ required: true, message: '请选择地区' }],
        address: [{ required: true, message: '请输入详细地址' }],
        level_id: [{ required: true, message: '请选择经销商等级' }],
        up_name: [{ required: true, message: '请选择上级经销商' }],
      },
    });
    const ruleForm = ref();
    const $route = inject('$route');
    const $Modal = inject('$Modal');
    const $router = inject('$router');
    const _lodash = inject('_lodash');
    // 经纬度选择完毕
    const confirm = (value) => {
      form.value.lat = value.lat;
      form.value.lng = value.lng;
      state.showMap = false;
    };
    // 销售区域选择省
    const selectProvince = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityList = state.provinceList[option.key].children;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: state.provinceList[option.key].name,
          city_name: '',
          area_name: '',
          id: [e],
        };
      } else {
        state.cityList = [];
        state.areaList = [];
        state.province = undefined;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: '',
          city_name: '',
          area_name: '',
          id: [],
        };
      }
    };
    // 销售区域选择市
    const selectCity = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(1, 2);
        state.areaList = state.cityList[option.key].children;
        state.area = undefined;
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          city_name: state.cityList[option.key].name,
          area_name: '',
        };
      } else {
        state.cityObj.id.splice(1, 2);
        state.areaList = [];
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          ...state.cityObj,
          city_name: '',
          area_name: '',
        };
      }
    };
    // 销售区域选择区
    const selectArea = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(2, 1);
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          area_name: state.areaList[option.key].name,
        };
      } else {
        state.area = undefined;
        state.cityObj.id.splice(2, 1);
        state.cityObj = {
          ...state.cityObj,
          area_name: '',
        };
      }
    };
    // 对比上级经销商销售区域
    const contrast = () => {
      var superiorArea = state.superiorArea; //上级销售区域
      var left = state.cityObj; //左边数组
      if (_lodash.indexOf(left.id, 100000) == -1) {
        left.id.unshift(100000);
      }
      for (var i in superiorArea) {
        if (
          superiorArea[i].province_name == left.province_name &&
          superiorArea[i].city_name == left.city_name &&
          superiorArea[i].area_name == left.area_name
        ) {
          return true;
        }
        if (
          superiorArea[i].province_name == left.province_name &&
          superiorArea[i].city_name == left.city_name
        ) {
          if (superiorArea[i].id.length < left.id.length) {
            return true;
          }
        }
        if (
          superiorArea[i].province_name == left.province_name &&
          superiorArea[i].city_name !== left.city_name
        ) {
          if (superiorArea[i].id.length < left.id.length) {
            return true;
          }
        }
        if (superiorArea.length == 1 && superiorArea[i].id.length == 1) {
          return true;
        }
      }
    };
    // 添加销售区域
    const addCity = () => {
      var left = state.cityObj; //左边数组
      var right = state.rigthArr; //右边数组
      var superiorArea = state.superiorArea; // 上级经销商销售区域
      if (superiorArea.length > 0) {
        var contrastType = contrast(); //对比结果
        if (!contrastType) {
          message.error('该区域不在上级经销商销售范围！');
          return false;
        }
      }
      if (_lodash.indexOf(left.id, 100000) !== -1) {
        left.id = _lodash.filter(left.id, function (o) {
          return o != 100000;
        });
      }
      if (left.id.length == 0) {
        left.id.unshift(100000);
        left.country_name = '全国';
        if (right.length == 0) {
          right.push(_lodash.cloneDeep(left));
          clearCityArr();
        } else {
          message.error('已有相同区域！');
        }
        return;
      }
      if (right.length == 0) {
        left.id.unshift(100000);
        right.push(_lodash.cloneDeep(left));
        clearCityArr();
        return false;
      } else {
        left.id.unshift(100000);
        for (var i in right) {
          if (left.country_name == '全国' || right[i].country_name == '全国') {
            message.error('已有相同区域！');
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name &&
            right[i].area_name == left.area_name
          ) {
            message.error('已有相同区域！');
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name
          ) {
            if (right[i].id.length !== left.id.length) {
              message.error('已有相同区域！');
              return false;
            }
          }
          if (right[i].province_name == left.province_name) {
            if (right[i].city_name == '' || left.city_name == '') {
              message.error('已有相同区域！');
              return false;
            }
          }
        }
      }
      right.push(_lodash.cloneDeep(left));
      clearCityArr();
    };
    // 清空
    const clearCityArr = () => {
      state.province = undefined;
      state.city = undefined;
      state.area = undefined;
      state.cityList = [];
      state.areaList = [];
      state.cityObj = {
        country_name: '',
        province_name: '',
        city_name: '',
        area_name: '',
        id: [],
      };
    };
    // 删除销售区域
    const delRegion = (e) => {
      state.rigthArr.splice(e, 1);
    };
    //选择省市区
    const onChangeAddress = (e, s) => {
      if (
        state.mapProvince.province_name != s[0].name ||
        state.mapProvince.city_name != s[1].name ||
        state.mapProvince.area_name != s[2].name
      ) {
        //重置经纬度
        form.value.lat = '';
        form.value.lng = '';
      }

      form.value.province = e[0];
      form.value.city = e[1];
      form.value.region = e[2];
      state.mapProvince = {
        province_name: s[0].name,
        city_name: s[1].name,
        area_name: s[2].name,
      };
    };

    const changeVal = (e) => {
        //重置经纬度
        form.value.lat = '';
        form.value.lng = '';
    };

    // 获取经销商等级
    const getLevel = async () => {
      let res = await getDealerLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data;
      } else {
        message.error(res.msg);
      }
    };
    // 选择等级
    const selectLevel = (e, s) => {
      state.level = s.key;
      state.dealerLevel=state.levelList[s.key].level
      form.value.up_name = '';
      form.value.parent_dealer_id = '';
      state.superiorArea = [];
      state.rigthArr = [];
      form.value.sale_cat_id = undefined;
      clearCityArr();
    };
    //选择经销商
    const dealerSelect = (e) => {
      if (e == 0) {
        form.value.up_name = '总部';
        form.value.parent_dealer_id = e;
        state.dealerSelectType = false;
         state.superiorArea=[]
      } else {
        form.value.up_name = e.dealer_name;
        form.value.parent_dealer_id = e.dealer_id;

         state.dealerSelectType = true;
        getSelectDealerMore();
      }
      form.value.sale_cat_id = undefined;
      state.rigthArr = [];
      clearCityArr();
      state.showDealer = false;
    };
    //获取选择经销商的详情
    const getSelectDealerMore = async () => {
      let res = await getDealerMore(form.value.parent_dealer_id).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.superiorArea = res.data.sale_area_text || [];
        state.level = res.data.level || 0;
        state.dealerLevel=state.levelList.filter(v=>v.level_id==form.value.level_id)[0].level

      } else {
        message.error(res.msg);
      }
    };
    //获取省市区
    const getAreaList = async (arr) => {
      let result = await getArea().then((res) => res);
      state.provinceList = result.data;
      state.addressList = result.data;
    };
    const getMore = async (id) => {
      const hide = message.loading('正在加载中...', 0);
      let res = await getDealerMore(id).then((res) => res.data);
      if (iscode(res)) {
        form.value = res.data;
        form.value.address_list = [
          res.data.province,
          res.data.city,
          res.data.region,
        ];
        form.value.up_name = res.data.parent_dealer_name;
        form.value.level_id = res.data.level;
        state.rigthArr = res.data.sale_area_text;
        state.mapProvince = {
          province_name: res.data.province_name || '',
          city_name: res.data.city_name || '',
          area_name: res.data.region_name || '',
        };
        getSelectDealerMore();
        setTimeout(hide);
      } else {
        message.error(res.msg);
        setTimeout(hide);
      }
    };
    // 获取销售大区
    const SaleCatList=ref()
    const getSaleCatList=async()=>{
     let result=await getSaleCat().then(res=>res.data).catch(error=>error)
     console.log(result)
     SaleCatList.value=result.data
    }
    const onSubmit = () => {
      if (state.rigthArr.length == 0) {
        message.error('请选择销售区域');
        return false;
      } else {
        form.value.sale_area = [];
        for (var i in state.rigthArr) {
          state.rigthArr[i].id = _lodash.uniq(state.rigthArr[i].id)
          form.value.sale_area.push(_lodash.join(_lodash.uniq(state.rigthArr[i].id), ','));
        }
        form.value.sale_area_text = state.rigthArr;
      }
      ruleForm.value
        .validate()
        .then(async () => {
          let res;
          const hide = message.loading('正在加载中...', 0);
          if ($route.query.type == 'add') {
            res = await dealerAdd(form.value).then((res) => res.data);
          } else {
            res = await dealerEdit($route.query.id, form.value).then(
              (res) => res.data
            );
          }
            setTimeout(hide);
          if (iscode(res)) {
            message.success(res.msg);
            setTimeout(() => {
              if ($route.query.active) {
                $router.push({
                  path: '/customer/dealer/dealer_setup',
                  query: { active: $route.query.active },
                });
              } else {
                $router.go(-1);
              }
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error('请完善表单！');
        });
    };
    const dealerlevelsubmit = () => {
      state.showDealerLevel = false;
      getLevel();
    };
    onMounted(async () => {
    await  getAreaList();
    await  getLevel();
    getSaleCatList()
      if ($route.query.type == 'edit' || $route.query.type == 'look') {
        getMore($route.query.id);
      }
      if ($route.query.type == 'add') {
        let rulesObj = {
          password: [
            { required: true, message: '请输入密码' },
          ],
        };
        state.rules = _lodash.merge(state.rules, rulesObj);
      }
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      confirm,
      onChangeAddress,
      selectProvince,
      selectCity,
      selectArea,
      addCity,
      delRegion,
      dealerSelect,
      getSelectDealerMore,
      contrast,
      clearCityArr,
      selectLevel,
      dealerlevelsubmit,
      changeVal,
      SaleCatList
    };
  },
};
</script>
<style>
.region_list span:last-child .don {
  display: none;
}
</style>
